"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagFjIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagFjIcon = (0, _mobxReact.observer)(_class = (_FlagFjIcon = /*#__PURE__*/function (_React$Component) {
  function FlagFjIcon() {
    _classCallCheck(this, FlagFjIcon);
    return _callSuper(this, FlagFjIcon, arguments);
  }
  _inherits(FlagFjIcon, _React$Component);
  return _createClass(FlagFjIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 101 101"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#1DB5D7",
        d: "M0 0h100.2v100.2H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M62.6 38.5v14.3c0 9.6 12.5 12.5 12.5 12.5s12.5-2.9 12.5-12.5V38.5l-12.5-3.6-12.5 3.6z",
        fill: "#F3F3F3"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M87.7 39.4V34h-25v5.4h10.7v10.7H62.6v3.6h10.7v12c1.1.4 1.8.5 1.8.5s.7-.2 1.8-.5v-12h10.7v-3.6H76.9V39.4h10.8z",
        fill: "#D80027"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#F0F0F0",
        d: "M50.1 0v9.6l-7.9 7.8h7.9v15.3H39.8l10.3 10.2v7.2h-4.7L32.7 37.3v12.8H17.4V34.9L2.2 50.1H0v-9.6l7.9-7.8H0V17.4h10.3L0 7.1V0h4.6l12.8 12.8V0h15.3v15.2L47.9 0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#D80027",
        d: "M0 29.7h20.3v20.4h9.4V29.7h20.4v-9.4H29.7V0h-9.4v20.3H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#0052B4",
        d: "M32.7 32.7l17.4 17.4v-4.9L37.6 32.7z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#F0F0F0",
        d: "M32.7 32.7l17.4 17.4v-4.9L37.6 32.7z"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        fill: "#D80027"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M32.7 32.7l17.4 17.4v-4.9L37.6 32.7zM12.5 32.7L0 45.2v4.9l17.4-17.4z"
      })), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#0052B4",
        d: "M17.4 17.4L0 0v4.9l12.5 12.5z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#F0F0F0",
        d: "M17.4 17.4L0 0v4.9l12.5 12.5z"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        fill: "#D80027"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M17.4 17.4L0 0v4.9l12.5 12.5zM37.6 17.4L50.1 4.9V0L32.7 17.4z"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagFjIcon.defaultProps = {
  width: '20px'
}, _FlagFjIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagFjIcon);